// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector, Selector} from 'reselect';
import { ILTCourse } from '../../../types/Model';
import { IltCourseInformationState } from '../../reducers/iltCourseDataReducer';

import { RootState } from '../../rootReducer';

export const IltCoursesRaw = (state: RootState):IltCourseInformationState => state.iltCourseDataReducer

/**
 * when select specific IltCourse, return the content
 */
export const makeIltCourseByIdSelector = (id: number): Selector<RootState, ILTCourse> =>
  createSelector(
    IltCoursesRaw,
    (IltCoursesReducer) => IltCoursesReducer.iltCourses[id] || {} as ILTCourse
  );

export const makeIsFetchingIltCourse = (): Selector<RootState, boolean> => {
  return createSelector(
    IltCoursesRaw,
    (IltCoursesReducer) => IltCoursesReducer.isLoading
  );
};

export const makeIltCourseHasCourseByIdSelector = (id: number): Selector<RootState, boolean> =>
  createSelector(
    makeIltCourseByIdSelector(id),
    (IltCourse) => IltCourse.hasCourse || false
  );

export const makeIltCourseHasSampleByIdSelector = (id: number): Selector<RootState, boolean> =>
  createSelector(
    makeIltCourseByIdSelector(id),
    (IltCourse) => IltCourse.hasSample || false
  );

export const makeError= (): Selector<RootState, Error | undefined> => {
  return createSelector(
    IltCoursesRaw,
    (IltCoursesReducer) => IltCoursesReducer.error
  );
};
